
/**
* @memberof rmOBA
* @ngdoc service
* @name rmState
* @description 
*   States management throughout the app
*/

rmOBA.factory('rmState', function () {
        var state = {
            stage1Passed: false,
            stage2Passed: false
        }
        return {

            /**
            * @memberof rmState
            * @function get
            * @desc Retreive state data
            * @returns {object} entire state object
            */ 
            get: function() {
                return state;
            },


            /**
            * @memberof rmState
            * @function set
            * @desc Set current state
            * @param {string} variable State variable to be set 
            * @param {string|number} newValue New value to set the variable to   
            * @returns {object} array of all data objects
            */ 
            set: function(variable, newValue) {
                state[variable] = newValue;
                return state;
            }
        };
});